export default __webpack_public_path__ + "static/media/q25_step3.04e2dce7.png";